export default function normalizeUser(user = {}) {
    return {
      email: user?.email,
      phoneNumber: user?.phoneNumber ?? '',
      name: user?.name ?? '',
      familyName: user?.lastname ?? '',
      nickName: user?.nickName ?? '',
      iban: user?.iban ?? '',
      birthdate: user?.dob ?? '',
      country: user?.addressCountry ?? 'DE',
      city: user?.addressCity  ?? '',
      postalCode: user?.addressPostalCode ?? '',
      address: user?.addressLine1 ?? '',
      motivation: user?.motivationQuote ?? '',
      isSendEmailEnabled: user?.sendEmailEnabled ?? false,
      tipsSmsDisabled: user?.tipsSmsDisabled ?? false,
      onboarding: user?.onboarding  ?? false,
      disableIbanTransfer: user?.disableIbanTransfer  ?? false,
      ibanStatus: user?.ibanStatus  ?? false,
      photoUrl: user?.photoUrl  ?? '',
      username: user?.username ?? '',
      accReference: user?.accReference ?? '',
      mitarbeiterid: '',
      payoutPsp: user?.payoutPsp ?? 'Stripe',
      checkPayoutThreshold: user?.checkPayoutThreshold  ?? false,
      privateInfo: user?.privateInfo ?? true,
    }
}